module.exports = {"640302100":"金积镇","640302101":"金银滩镇","640302102":"高闸镇","640302103":"扁担沟镇","640302104":"上桥镇","640302105":"古城镇","640302106":"金星镇","640302107":"胜利镇","640302200":"东塔寺乡","640302201":"板桥乡","640302202":"马莲渠乡","640302203":"郭家桥乡","640302400":"巴浪湖农场","640302401":"孙家滩管委会","640302402":"太阳山开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640302.json
// module id = 2821
// module chunks = 0